import { colorManagerAtom } from '@/store/uiStore';
import clsx from 'clsx';
import { useAtom } from 'jotai';
import React from 'react';

interface DTSAssetEditButtonsProps {
  onEditClick?: () => void;
}

export default function DTSAssetEditButton({ onEditClick }: DTSAssetEditButtonsProps) {
  const [colorManager] = useAtom(colorManagerAtom);

  return (
    <div
      className={clsx(
        colorManager.text ?? 'text-white',
        'relative inline-flex items-end gap-2 text-nhg text-[14px] font-[450] float-right mt-2'
      )}
      onClick={onEditClick}
    >
      <span className="text-[#A2EE00] font-nhg text-[14px] leading-[14px] tracking-[0.15em]">
        EDIT
      </span>
    </div>
  );
}
